import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { addKMSAsync } from "./thunks/AddKMSAsync";
import { KeyManager } from "../../../api/controlPlaneApi";

export interface IAddKMS {
  addKMSLoading: boolean;
  selectedSite: string;
  name: string;
  namespace: string;
  replicas: string;
  expose: boolean;
  volumeSize: string;
  sizeFactor: string;
  imageName: string;
  storageClass: string;
  volumeName: string;
  KMSProcessed: KeyManager | null;
}

const initialState: IAddKMS = {
  addKMSLoading: false,
  selectedSite: "",
  name: "",
  namespace: "",
  replicas: "0",
  expose: false,
  volumeSize: "0",
  sizeFactor: "Gi",
  imageName: "",
  storageClass: "",
  volumeName: "",
  KMSProcessed: null,
};

export const addKMSSlice = createSlice({
  name: "addKMS",
  initialState,
  reducers: {
    setAddKMSLoading: (state, action: PayloadAction<boolean>) => {
      state.addKMSLoading = action.payload;
    },
    setKMSSelectedSite: (state, action: PayloadAction<string>) => {
      state.selectedSite = action.payload;
    },
    setKMSName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setKMSNamespace: (state, action: PayloadAction<string>) => {
      state.namespace = action.payload;
    },
    setKMSVolumeSize: (state, action: PayloadAction<string>) => {
      state.volumeSize = action.payload;
    },
    setKMSSizeFactor: (state, action: PayloadAction<string>) => {
      state.sizeFactor = action.payload;
    },
    setKMSStorageClass: (state, action: PayloadAction<string>) => {
      state.storageClass = action.payload;
    },
    setKMSReplicas: (state, action: PayloadAction<string>) => {
      state.replicas = action.payload;
    },
    setKMSExpose: (state, action: PayloadAction<boolean>) => {
      state.expose = action.payload;
    },
    setKMSImageName: (state, action: PayloadAction<string>) => {
      state.imageName = action.payload;
    },
    setKMSVolumeName: (state, action: PayloadAction<string>) => {
      state.volumeName = action.payload;
    },
    resetAddKMSForm: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addKMSAsync.pending, (state) => {
        state.addKMSLoading = true;
      })
      .addCase(addKMSAsync.rejected, (state) => {
        state.addKMSLoading = false;
      })
      .addCase(addKMSAsync.fulfilled, (state, action) => {
        state.addKMSLoading = false;
        state.KMSProcessed = action.payload;
      });
  },
});

export const {
  setAddKMSLoading,
  resetAddKMSForm,
  setKMSSelectedSite,
  setKMSName,
  setKMSNamespace,
  setKMSVolumeSize,
  setKMSSizeFactor,
  setKMSStorageClass,
  setKMSReplicas,
  setKMSExpose,
  setKMSImageName,
  setKMSVolumeName,
} = addKMSSlice.actions;

export default addKMSSlice.reducer;
